import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import { bootstrapAttribution } from "@/lib/attribution";

import Landing from "@/pages/Landing";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import Quiz from "@/pages/Quiz";
import Results from "@/pages/Results";
import Login from "@/pages/Login";
import ForPartners from "@/pages/ForPartners";
import PartnerApply from "@/pages/PartnerApply";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import StateHub from "@/pages/StateHub";
import StateDetail from "@/pages/StateDetail";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminPartners from "@/pages/admin/AdminPartners";
import AdminApplications from "@/pages/admin/AdminApplications";
import AdminArticles from "@/pages/admin/AdminArticles";
import AdminQuiz from "@/pages/admin/AdminQuiz";
import AdminSettings from "@/pages/admin/AdminSettings";

import PartnerDashboard from "@/pages/partner/PartnerDashboard";

function App() {
  useEffect(() => {
    bootstrapAttribution();
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Public */}
              <Route path="/" element={<Landing />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/articles/:slug" element={<ArticleDetail />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/results/:leadId" element={<Results />} />
              <Route path="/for-partners" element={<ForPartners />} />
              <Route path="/for-partners/apply" element={<PartnerApply />} />
              <Route path="/login" element={<Login />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/senior-care" element={<StateHub />} />
              <Route path="/senior-care/:state" element={<StateDetail />} />

              {/* Admin */}
              <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/leads" element={<ProtectedRoute role="admin"><AdminLeads /></ProtectedRoute>} />
              <Route path="/admin/partners" element={<ProtectedRoute role="admin"><AdminPartners /></ProtectedRoute>} />
              <Route path="/admin/applications" element={<ProtectedRoute role="admin"><AdminApplications /></ProtectedRoute>} />
              <Route path="/admin/articles" element={<ProtectedRoute role="admin"><AdminArticles /></ProtectedRoute>} />
              <Route path="/admin/quiz" element={<ProtectedRoute role="admin"><AdminQuiz /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute role="admin"><AdminSettings /></ProtectedRoute>} />

              {/* Partner */}
              <Route path="/partner" element={<ProtectedRoute role="partner"><PartnerDashboard /></ProtectedRoute>} />

              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
